import React from "react";
import styled from "styled-components";
import Breakpoints from "./styles/Breakpoints";
import { Colors } from "./styles/Colors";
import { DomeTextStyles } from "./typography";

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  padding: 20px;

  @media ${Breakpoints.tablet} {
    display: flex;
    justify-content: center;

    > button {
      margin: 10px 24px;
    }
  }
`;

const Link = styled.button`
  ${DomeTextStyles}

  appearance: none;
  background: 0;
  border: 0;

  color: ${Colors.sage};

  transition: color 0.5s ease;

  margin: 10px 0;

  &:hover {
    color: ${Colors.hunter};
  }
`;

export default function BlogCategories({ onScroll }) {
  return (
    <Wrapper>
      <Link onClick={() => onScroll("stories")}>Stories</Link>
      <Link onClick={() => onScroll("spirit")}>Spirit</Link>
      <Link onClick={() => onScroll("self-care")}>Self-Care</Link>
      <Link onClick={() => onScroll("skin-care")}>Skin Care</Link>
    </Wrapper>
  );
}
